import * as React from 'react';
import { connect } from 'react-redux';

import * as Actions from '../actions';
import Alert, { AlertCategoryEnum } from '../../../misc/components/Alert';
import { AnalyseState } from '../interfaces/state';

export interface ResumePlaybackProps {
    hasBeenPreviouslyPlayed: boolean;

    dispatch?: any;
}

export const ResumePlayback = (props: ResumePlaybackProps) => {
    return (
        <Alert show={props.hasBeenPreviouslyPlayed} category={AlertCategoryEnum.Info}>
            <i className="fa fa-info-circle icon fa-fw" aria-hidden="true"></i>
            This recording has been previously played would you like to resume playback? <a onClick={() => props.dispatch(Actions.ResumePlaybackAction.create())}>Resume</a>
        </Alert>
    );
}

function mapStateToProps(state: AnalyseState) {
    return {
        hasBeenPreviouslyPlayed: state.core.storedPlaybackTime !== null,
    };
}

export default connect<ResumePlaybackProps, any, void>(mapStateToProps)(ResumePlayback);
